import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=02df8b2d"
import script from "./MainTabs.vue?vue&type=script&lang=js"
export * from "./MainTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports